require.config({
	baseUrl: "/resources/𝓥𝓔𝓡𝓢𝓘𝓞𝓝/",
	paths: {
		"@vergleichde/client-detection": "vendor/@vergleichde/client-detection/dist/index",
		"@vergleichde/touch-detection": "vendor/@vergleichde/client-detection/dist/touch-detection",
		"@vergleichde/mobile-detection": "vendor/@vergleichde/client-detection/dist/mobile-detection",
		"@vergleichde/browser-detection": "vendor/@vergleichde/client-detection/dist/browser-detection",
		"@vergleichde/locale-formatter": "vendor/@vergleichde/locale-formatter/dist/locale-formatter",

		"hypo_custom": "_assets/hypo-custom/JavaScript",

		// Former includeJSFooterlibs libraries
		"@sentry/browser": "vendor/@sentry/browser/build/bundle.min",
		"async": "vendor/requirejs-plugins/src/async",
		"jquery": "vendor/jquery/dist/jquery.min",
		"jquery-ui": "vendor/jquery-ui/jquery-ui.min",
		"jquery-ui/ui": "vendor/jquery-ui/ui",
		"bootstrap": "vendor/bootstrap-sass/assets/javascripts/bootstrap.min",
		"mustache": "vendor/mustache/mustache.min",
		"hammerjs": "vendor/hammerjs/hammer.min",
		"iframe-resizer": "vendor/iframe-resizer/js/iframeResizer.min",
		"js-cookie": "vendor/js-cookie/src/js.cookie",
		"jquery-countto": "vendor/jquery-countto/jquery.countTo",
		"jquery-waypoints": "vendor/waypoints/lib/jquery.waypoints.min",
		"lottie-web": "vendor/lottie-web/build/player",
		"owl-carousel": "_assets/hypo-custom/Vendor/owl.carousel/dist/owl.carousel",
		"webfontloader": "vendor/webfontloader/webfontloader",
		"moment": "vendor/moment/min/moment.min",
		"web-vitals": "vendor/web-vitals/dist/web-vitals",
		"swiper": "vendor/swiper/swiper-bundle.min",

		//Angular apps
		"baufinanzierungsantrag": "apps/baufinanzierungsantrag",
		"zinschartAppModule": "apps/zinschart/vergleichde-zinschart-es2015",
		"zinschartAppNoModule": "apps/zinschart/vergleichde-zinschart-es5",
		"geldanlageVergleichBootstrap": "apps/geldanlage-vergleich-2019/bootstrap-angular-app",
		"baufinanzierungsantrag2020Bootstrap": "apps/baufinanzierung-antrag-2020/bootstrap-angular-app"
	},

	map: {
		"*": {
			"configuration": "hypo_custom/Typescript/Configuration/Configuration",
			"web-vitals/base": "vendor/web-vitals/dist/web-vitals.base.umd",
			"lottie-web": "vendor/lottie-web/build/player/lottie_light"
		},
	},

	shim: {
		"@sentry/browser": {
			exports: "Sentry"
		},

		"jquery-waypoints": {
			deps: ["jquery"],
			exports: "window.Waypoint",
		},

		"bootstrap": {
			deps: ["jquery"],
			exports: "$.fn.popover", //Use any plugin as indicator for RequireJS (see https://stackoverflow.com/a/13556882/6787528)
		},

		"owl-carousel": {
			deps: ["jquery"],
			exports: "$.fn.owlCarousel", //Use any plugin as indicator for RequireJS (see https://stackoverflow.com/a/13556882/6787528)
		},

		"baufinanzierungsantrag/polyfills": {
			deps: ["baufinanzierungsantrag/runtime"]
		},

		"baufinanzierungsantrag/main": {
			deps: ["baufinanzierungsantrag/polyfills"]
		},

		"@vergleichde/form-element/form-element.vergleich": {
			deps: [
				"jquery-ui",
				"jquery-ui/ui/i18n/datepicker-de",
			],
		},

		"vendor/jquery-ui/ui/i18n/datepicker-de": {
			deps: [
				"jquery-ui/ui/widgets/datepicker",
			],
		},
	},

	waitSeconds: 30,
	enforceDefine: false,
});
